import { render, staticRenderFns } from "./ProceduresItem.vue?vue&type=template&id=8e2123ee&scoped=true"
import script from "./ProceduresItem.vue?vue&type=script&lang=js"
export * from "./ProceduresItem.vue?vue&type=script&lang=js"
import style0 from "./ProceduresItem.vue?vue&type=style&index=0&id=8e2123ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2123ee",
  null
  
)

export default component.exports